import NavLinkGroup from '../../../app/components/main-menu/components/nav-link-group/NavLinkGroup';
import UrlsService from '../../../../common/router/services/urlsService.mdl';

export default function ChangeLogsLinks(): React.JSX.Element {

    return (
        <NavLinkGroup to={UrlsService.changeLogs()} label="Change Logs" iconName="icon-history"/>
    );
}
